export const boxShadowExtraSmall = "0px 1px 2px 0px rgba(0, 0, 0, 0.10)";
export const boxShadowSmall = "0px 4px 8px -2px rgba(16, 24, 40, 0.04), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)";
export const boxShadowMedium = "0px 10px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)";
export const boxShadowLarge = "0px 16px 24px -4px rgba(0, 0, 0, 0.08), 0px 8px 8px -4px rgba(13, 27, 42, 0.03)";
